



























































































































































import firebase from "firebase";
import { Component, Vue } from "vue-property-decorator";
import SoundManager from "../soundManager";
const VueProps = Vue.extend();
@Component<GameRank>({})
export default class GameRank extends VueProps {
  public rankData: any = {
    rank1id: "",
    rank1cc: "",
    rank1img: "",
    rank2id: "",
    rank2cc: "",
    rank2img: "",
    rank3id: "",
    rank3cc: "",
    rank3img: "",
    rank0id: "",
    rank0cc: "",
    rank0img: "",
    totoal: "",
    count: "",
  };
  public SetInfo(name: any, cc: any, img: any) {
    this.rankData.rank0id = name;
    this.rankData.rank0cc = this.addCommas(cc.toString()) + " cc";
    this.rankData.rank0img = img;

    const target: any = this.$refs["targetImage0"];
    target.setAttributeNS(
      "http://www.w3.org/1999/xlink",
      "href",
      this.rankData.rank0img
    );
    var o = this;
    var db = firebase.firestore();

    db.collection("holdyourfart")
      .orderBy("score", "desc")
      .limit(3)
      .get()
      .then((querySnapshot): void => {
        var cnt = 1;
        querySnapshot.forEach((doc): void => {
          o.rankData["rank" + cnt + "id"] = doc.data().name;
          o.rankData["rank" + cnt + "cc"] =
            o.addCommas(doc.data().score.toString()) + " cc";
          o.rankData["rank" + cnt + "img"] = doc.data().url;

          // doc.data() is never undefined for query doc snapshots
          console.log(doc.id, " => ", doc.data());
          const target: any = this.$refs["targetImage" + cnt];
          target.setAttributeNS(
            "http://www.w3.org/1999/xlink",
            "href",
            doc.data().url
          );
          cnt++;
        });
      })
      .catch((error): void => {
        console.log("Error getting documents: ", error);
      });

    db.collection("holdyourfart")
      .doc("common")
      .get()
      .then((doc) => {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          o.rankData.count =
            doc.data()?.count + " " + this.$i18n.t("message.player");
          o.rankData.total = o.addCommas(doc.data()?.total.toString()) + " cc";
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error): void => {
        console.log("Error getting documents: ", error);
      });
  }
  public close(): void {
    SoundManager.btnSound();
    console.log("close");
    this.$emit("close");
  }
  private addCommas(nStr: string) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }
}
